var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigationLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.523,
    height: 17.581,
    viewBox: "0 0 13.523 17.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-lock",
    "data-name": "Icon ionic-ios-lock",
    d: "M18.583,9.46H17.569V7.487a4.057,4.057,0,1,0-8.114-.055V9.46H8.44a1.7,1.7,0,0,0-1.69,1.69v8.114a1.7,1.7,0,0,0,1.69,1.69H18.583a1.7,1.7,0,0,0,1.69-1.69V11.151A1.7,1.7,0,0,0,18.583,9.46ZM14.1,14.734v2.908a.606.606,0,0,1-.562.609.592.592,0,0,1-.621-.592V14.734a1.352,1.352,0,1,1,1.183,0ZM16.385,9.46H10.638V7.432a2.874,2.874,0,0,1,5.747,0Z",
    transform: "translate(-6.75 -3.374)",
    fill: "#de6438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigationLock);
export default __webpack_public_path__ + "static/media/icon-navigation-lock.11474c392d5122a9c26a0598765e5b54.svg";
export { ForwardRef as ReactComponent };